import { render } from "./DeleteDossierModal.vue?vue&type=template&id=5ce66d14&scoped=true"
import script from "./DeleteDossierModal.vue?vue&type=script&lang=js"
export * from "./DeleteDossierModal.vue?vue&type=script&lang=js"

import "./DeleteDossierModal.vue?vue&type=style&index=0&id=5ce66d14&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce66d14"]])

export default __exports__